//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: '',
  components: {
    current: function current() {
      return import('./components/current');
    },
    self: function self() {
      return import('./components/self');
    },
    assessStatistics: function assessStatistics() {
      return import('@/views/user/workStatistics/components/assessStatistics');
    },
    auditProcess: function auditProcess() {
      return import('./components/auditProcess');
    }
  },
  props: {},
  data: function data() {
    return {
      tabCur: 0,
      id: 0,
      checkBtn: true,
      isTips: true,
      addBtn: false,
      status: 0,
      strType: '',
      rowData: {}
    };
  },
  computed: {},
  watch: {
    tabCur: function tabCur(newVal, old) {
      this.getList();
    }
  },
  methods: {
    selfHandleCheck: function selfHandleCheck(data, str, row) {
      if (row) {
        this.rowData = row;
      }
      this.checkBtn = false;
      this.status = data.status;
      this.id = data.id;
      this.tabCur = data.tabIndex;
      this.strType = str;
    },
    auditProcess: function auditProcess(data) {
      if (data.return == 1) {
        this.checkBtn = true;
        this.getList();
      }
    },
    saveOk: function saveOk() {
      this.checkBtn = true;
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      this.$nextTick(function () {
        switch (parseInt(_this.tabCur)) {
          case 1:
            setTimeout(function () {
              _this.$refs.self.getTableData();
            }, 300);
            break;
          case 2:
            setTimeout(function () {
              _this.$refs.assessStatistics.type = 0;
              _this.$refs.assessStatistics.getTableData();
            }, 300);
            break;
        }
      });
    }
  }
};